import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from "react-router";

import { LoadingOverlay } from "../../../../shared/ui/common/LoadingOverlay";
import { useCenter } from "../../../center";

/**
 * Guards the administration surface.
 *
 * Anyone who is not a confirmed administrator of a centre is sent home rather
 * than shown a locked screen: a therapist who works alone has no centre to be
 * refused from, and telling them one exists would be inventing a door.
 *
 * The guard is a convenience, not the control. Every centre endpoint decides
 * for itself, from stored membership, on every request — this only spares the
 * user a screen that would refuse them anyway.
 */
export default function CenterAdminRouteGuard() {
    const { isAdmin, loading } = useCenter();
    const { t } = useTranslation();

    if (loading) return <LoadingOverlay visible={true} message={t("common.loading")} />;

    if (!isAdmin) return <Navigate to="/" replace />;

    return <Outlet />;
}
